import { currencyConstants } from '@utils/constants';
import currencySimpleUtility from '@utils/currencySimple';
import mutationTypes from '@helpers/storeFactories/helpers/mutationTypes';

const STORE_NAME = 'payment';

export default {
    name: STORE_NAME,
    namespaced: true,
    state: {
        cardTypes: null,
        types: null,
    },
    mutations: {
        [mutationTypes.SET_DATA](state, data) {
            const cardTypes = data.paymentCardTypes || { items: [] };
            const types = data.paymentTypes || { items: [] };

            state.cardTypes = cardTypes;
            state.types = types;
        },
        [mutationTypes.CLEAR_DATA](state) {
            state.cardTypes = null;
            state.types = null;
        },
    },
    getters: {
        cardTypesRevenue:
            (state) =>
            (returnType = Array) => {
                let percentCount = 0,
                    returnTypeObject = [],
                    returnTypeArray = [];

                if (state.cardTypes) {
                    state.cardTypes.items.forEach((item) => {
                        percentCount += item.revenuePercentage;
                        returnTypeArray.push([
                            item.type,
                            item.revenueTotal,
                            `${item.type}\n${currencySimpleUtility(item.revenueTotal, currencyConstants.DEFAULT)} (${item.revenuePercentage}%)`,
                        ]);
                        returnTypeObject.push({
                            type: item.type,
                            percentage: `${item.revenuePercentage}%`,
                            total: currencySimpleUtility(
                                item.revenueTotal,
                                currencyConstants.DEFAULT
                            ),
                        });
                    });
                }

                if (percentCount > 0) {
                    switch (returnType) {
                        case Object:
                            return returnTypeObject;
                        default:
                            return returnTypeArray;
                    }
                }

                return null;
            },
        cardTypesTransactions:
            (state) =>
            (returnType = Array) => {
                let percentCount = 0,
                    returnTypeObject = [],
                    returnTypeArray = [];

                if (state.cardTypes) {
                    state.cardTypes.items.forEach((item) => {
                        percentCount += item.transactionsPercentage;
                        returnTypeArray.push([
                            item.type,
                            item.transactionsPercentage,
                            `${item.type}\n${item.transactionsTotal} (${item.transactionsPercentage}%)`,
                        ]);
                        returnTypeObject.push({
                            type: item.type,
                            percentage: `${item.transactionsPercentage}%`,
                            total: item.transactionsTotal,
                        });
                    });
                }

                if (percentCount > 0) {
                    switch (returnType) {
                        case Object:
                            return returnTypeObject;
                        default:
                            return returnTypeArray;
                    }
                }

                return null;
            },
        typesRevenue:
            (state) =>
            (returnType = Array) => {
                let percentCount = 0,
                    returnTypeObject = [],
                    returnTypeArray = [];

                if (state.types) {
                    state.types.items.forEach((item) => {
                        percentCount += item.revenuePercentage;
                        returnTypeArray.push([
                            item.type,
                            item.revenueTotal,
                            `${item.type}\n${currencySimpleUtility(item.revenueTotal, currencyConstants.DEFAULT)} (${item.revenuePercentage}%)`,
                        ]);
                        returnTypeObject.push({
                            type: item.type,
                            percentage: `${item.revenuePercentage}%`,
                            total: currencySimpleUtility(
                                item.revenueTotal,
                                currencyConstants.DEFAULT
                            ),
                        });
                    });
                }

                if (percentCount > 0) {
                    switch (returnType) {
                        case Object:
                            return returnTypeObject;
                        default:
                            return returnTypeArray;
                    }
                }

                return null;
            },
        typesTransactions:
            (state) =>
            (returnType = Array) => {
                let percentCount = 0,
                    returnTypeObject = [],
                    returnTypeArray = [];

                if (state.types) {
                    state.types.items.forEach((item) => {
                        percentCount += item.transactionsPercentage;
                        returnTypeArray.push([
                            item.type,
                            item.transactionsPercentage,
                            `${item.type}\n${item.transactionsTotal} (${item.transactionsPercentage}%)`,
                        ]);
                        returnTypeObject.push({
                            type: item.type,
                            percentage: `${item.transactionsPercentage}%`,
                            total: item.transactionsTotal,
                        });
                    });
                }

                if (percentCount > 0) {
                    switch (returnType) {
                        case Object:
                            return returnTypeObject;
                        default:
                            return returnTypeArray;
                    }
                }

                return null;
            },
    },
};
